import type React from 'react';
import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';

interface Props {
  post: any;
}

const ComparisonContent: React.FC<Props> = (props: Props) => {
  const { post } = props;
  let featuredImage = <div />;
  const fimage = post.featured_image;
  if (fimage.url) {
    featuredImage = (
      <Image
        width={1600}
        height={900}
        className="size-full"
        sizes="100vw"
        src={fimage.url}
        alt="Article Image"
      />
    );
  }
  const body = post.body.map((slice, index) => {
    if (slice.slice_type === 'text') {
      return (
        <div className="text" key={index}>
          <PrismicRichText field={slice.primary.text} />
        </div>
      );
    }
    return null;
  });
  return (
    <main className="post-main my-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="single-post--header">
          <div className="col-span-12">
            <h1 className="headline">{post.title[0].text}</h1>
            {featuredImage}
            <div className="single-post--main max-w-xl mx-auto lg:max-w-3xl">
              {body}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ComparisonContent;
